'use client';

import { c as _c } from "react/compiler-runtime";
import Opera from "./Icons/Opera";
import Metamask from "./Icons/Metamask";
import Rabby from "./Icons/Rabby";
import SafePal from "./Icons/SafePal";
import Brave from "./Icons/Brave";
import MathWallet from "./Icons/MathWallet";
import TrustWallet from "./Icons/TrustWallet";
import TokenPocket from "./Icons/TokenPocket";
import Coin98 from "./Icons/Coin98";
import WalletConnect from "./Icons/WalletConnect";
import Image from 'next/image';
import 'viem/window';
// import { useWalletInfo } from '@reown/appkit/react'

interface WalletIconProps {
  [key: string]: any;
}
declare global {
  interface Window {
    // @ts-expect-error
    ethereum?: {
      isOpera?: boolean;
      isRabby?: boolean;
      isSafePal?: boolean;
      isBraveWallet?: boolean;
      isMathWallet?: boolean;
      isTrust?: boolean;
      isTrustWallet?: boolean;
      isTokenPocket?: boolean;
      isCoin98?: boolean;
      isMetaMask?: boolean;
    };
    coin98?: boolean;
  }
}
export default function WalletIcon(props) {
  const $ = _c(22);
  if (typeof window !== "undefined") {
    if (window.ethereum?.isOpera) {
      let t0;
      if ($[0] !== props) {
        t0 = <Opera {...props} />;
        $[0] = props;
        $[1] = t0;
      } else {
        t0 = $[1];
      }
      return t0;
    } else {
      if (window.ethereum?.isRabby) {
        let t0;
        if ($[2] !== props) {
          t0 = <Rabby {...props} />;
          $[2] = props;
          $[3] = t0;
        } else {
          t0 = $[3];
        }
        return t0;
      } else {
        if (window.ethereum?.isSafePal) {
          let t0;
          if ($[4] !== props) {
            t0 = <SafePal {...props} />;
            $[4] = props;
            $[5] = t0;
          } else {
            t0 = $[5];
          }
          return t0;
        } else {
          if (window.ethereum?.isBraveWallet) {
            let t0;
            if ($[6] !== props) {
              t0 = <Brave {...props} />;
              $[6] = props;
              $[7] = t0;
            } else {
              t0 = $[7];
            }
            return t0;
          } else {
            if (window.ethereum?.isMathWallet) {
              let t0;
              if ($[8] !== props) {
                t0 = <MathWallet {...props} />;
                $[8] = props;
                $[9] = t0;
              } else {
                t0 = $[9];
              }
              return t0;
            } else {
              if (Boolean(window.ethereum?.isTrust) || Boolean(window.ethereum?.isTrustWallet)) {
                let t0;
                if ($[10] !== props) {
                  t0 = <TrustWallet {...props} />;
                  $[10] = props;
                  $[11] = t0;
                } else {
                  t0 = $[11];
                }
                return t0;
              } else {
                if (window.ethereum?.isTokenPocket) {
                  let t0;
                  if ($[12] !== props) {
                    t0 = <TokenPocket {...props} />;
                    $[12] = props;
                    $[13] = t0;
                  } else {
                    t0 = $[13];
                  }
                  return t0;
                } else {
                  if (Boolean(window.ethereum?.isCoin98) || Boolean(window.coin98)) {
                    let t0;
                    if ($[14] !== props) {
                      t0 = <Coin98 {...props} />;
                      $[14] = props;
                      $[15] = t0;
                    } else {
                      t0 = $[15];
                    }
                    return t0;
                  } else {
                    if (window.ethereum?.isMetaMask) {
                      let t0;
                      if ($[16] !== props) {
                        t0 = <Metamask {...props} />;
                        $[16] = props;
                        $[17] = t0;
                      } else {
                        t0 = $[17];
                      }
                      return t0;
                    } else {
                      let t0;
                      if ($[18] !== props) {
                        t0 = <WalletConnect {...props} />;
                        $[18] = props;
                        $[19] = t0;
                      } else {
                        t0 = $[19];
                      }
                      return t0;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  let t0;
  if ($[20] !== props) {
    t0 = <Metamask {...props} />;
    $[20] = props;
    $[21] = t0;
  } else {
    t0 = $[21];
  }
  return t0;
}